import React from "react";
import Layout from "../../components/Layout";
import LeaveImportModal from "../../components/Admin/LeaveImportModal";

function LeaveImportPage() {
  return (
    <Layout>
      <LeaveImportModal open={true} onClose={() => window.history.back()} />
    </Layout>
  );
}

export default LeaveImportPage;
